import { schema } from 'normalizr';
import { businessSchema } from '../business/schema';
import { categorySchema } from '../categories/schema';

export const postSchema = new schema.Entity('posts', {
    business: businessSchema,
    categories: [categorySchema],
});
